/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useScreenSize } from '@avila-tek/ui/src';
import { Company } from '../../../models';
import { getSettings, rules } from '../reducer';
import AllyCard from '../../Ally/AllyCard';

interface CatalogueRowCarouselProps {
  sections?: {
    allies: Company[];
    categoryId: string;
  }[];
}

function CatalogueRowCarousel({ sections }: CatalogueRowCarouselProps) {
  const { allies } = sections[0];
  const { screenSize } = useScreenSize();

  const elementsToShow = React.useMemo(() => {
    const matchedRule = rules.find((rule) => screenSize > rule.maxWidth) || {
      elements: 1,
    };
    return matchedRule.elements;
  }, [screenSize]);

  const showMoreThanFourAllies = allies.length >= 4;
  const showTwoOrThreeAlliesWithSlider =
    allies.length >= 2 && allies.length <= 3 && elementsToShow === 1;

  return (
    <div className="slider-container">
      {showMoreThanFourAllies || showTwoOrThreeAlliesWithSlider ? (
        <Slider {...getSettings(allies)}>
          {sections[0].allies?.map((ally, index) => (
            <AllyCard
              key={index}
              ally={ally}
              categoryId={sections[0].categoryId}
            />
          ))}
        </Slider>
      ) : (
        <div className="w-full flex flex-wrap gap-5 ">
          {allies
            ?.slice(0, elementsToShow)
            .map((ally: Company, index: number) => (
              <AllyCard
                key={index}
                ally={ally}
                categoryId={sections[0].categoryId}
              />
            ))}
        </div>
      )}
    </div>
  );
}

export default CatalogueRowCarousel;
